// LoginError.jsx

import React from 'react';

// CSS
import './LoginError.css';

/**
 * LoginError Component
 * 
 * This component renders a login form error message.
 * 
 * @param {string} text - The text of the label.
 * 
 * @returns {ReactNode} The rendered component.
 */
const LoginError = ({ text }) => {

  // ----- RENDER ----- //

  return (

    <div
      className="login-error-container"
      style={{
        backgroundColor: "#FFFFFF22",
        borderColor: "#FFFFFF22",
        color: '#FFFFFF',
      }}
    >
      {text}
    </div>

  );
};

// Dev Tools
LoginError.displayName = 'LoginError';

export default LoginError;
